<template>
  <Modal :name="galleryName" :on-close="onClose" class="dcx-image-gallery">
    <Swiper v-if="show">
      <SwiperSlide v-for="image in images" :key="image.id">
        <figure>
          <img
            :src="image.img"
            :alt="image.caption"
            :class="`wp-image-${image.id}`"
          />
          <figcaption v-if="image.caption">
            <p v-html="image.caption"></p>
          </figcaption>
        </figure>
      </SwiperSlide>
    </Swiper>
  </Modal>
</template>

<script>
import Swiper from '~components/utils/Swiper.vue'
import SwiperSlide from '~components/utils/SwiperSlide.vue'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    galleryName() {
      if (!this.images || this.images.length === 0) return ''
      const id = this.images.reduce((sum, i) => (sum += i.id), 0)
      return `gallery-${id}`
    },
  },
  mounted() {
    this.openGallery()
  },
  methods: {
    onClose() {
      this.$store.dispatch('modal/hideModal')
      this.$emit('close-modal')
      this.show = false
    },
    openGallery() {
      this.$store.dispatch('modal/showModal', {
        showCloseButton: true,
        name: this.galleryName,
      })
      this.show = true
    },
  },
}
</script>

<style>
@import '~components/content/detail-view/elements/DCXImageGallery.css';
</style>
